import myAxios from "../utils/request";
export default {
  getOrderList(params) {
    return myAxios.post("/api/OrderLink/GetOrderList", params);
  }
};
